/**
 * Reads mappings between user handles and uids.  Useful for determining if a handle is already taken.
 */
export class HandleRepository {
}
//# sourceMappingURL=HandleRepository.js.map